/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { DndProvider } from "react-dnd-multi-backend";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
import "./Basis/Internationalisierung/i18n";
import AppRouter from "./AppRouter";
import AuthenticationContext from "./Basis/Authentication/AuthenticationContext";
import IstMandantGueltigContext from "./Basis/Authentication/IstMandantGueltigContext";
import PortalPruefer from "./Basis/Authentication/PortalPruefer";
import AppBreadcrumbs from "./Basis/Components/AppBreadcrumbs";
import AppBreadcrumbsContext from "./Basis/Components/AppBreadcrumbsContext";
import AppCoffeeMug from "./Basis/Components/AppCoffeeMug";
import AppCoffeeMugContext from "./Basis/Components/AppCoffeeMugContext";
import AppContext from "./Basis/Components/AppContext";
import AppDirektdruck from "./Basis/Components/AppDirektdruck";
import AppDirektdruckContext from "./Basis/Components/AppDirektdruckContext";
import AppDownload from "./Basis/Components/AppDownload";
import AppDownloadContext from "./Basis/Components/AppDownloadContext";
import AppHeader from "./Basis/Components/AppHeader";
import AppKontoContext from "./Basis/Components/AppKontoContext";
import AppMainContainer from "./Basis/Components/AppMainContainer";
import AppMandantContext from "./Basis/Components/AppMandantContext";
import AppMenuContext from "./Basis/Components/AppMenuContext";
import AppRollenContext from "./Basis/Components/AppRollenContext";
import AppSnackbar from "./Basis/Components/AppSnackbar";
import { AppSnackbarProvider } from "./Basis/Components/AppSnackbarContext";
import AppZahlungsmethodeSetzenDialog from "./Basis/Components/AppZahlungsmethodeSetzenDialog";
import CloudBrowserRouter from "./Basis/Components/CloudBrowserRouter";
import CookieBannerContext from "./Basis/Components/CookieBannerContext";
import GlobalErrorHandler from "./Basis/Components/GlobalErrorHandler";
import LoadingIndicatorSuspense from "./Basis/Components/LoadingIndicatorSuspense";
import ViewHistoryContext from "./Basis/Components/ViewHistoryContext";
import EmotionCacheProvider from "./Basis/Emotion/EmotionCacheProvider";
import GraphQLProvider from "./Basis/GraphQL/GraphQLProvider";
import Themes from "./Basis/MaterialUI/Themes";
import ConsoleLogger from "./Basis/Utils/ConsoleLogger";
import AppNotificationContext from "./Cloud/Benachrichtigungen/Components/AppNotificationContext";
import AppHelmet from "./Management/Mandanten/Components/AppHelmet";
import BannerMitteilungen from "./Management/Mitteilungen/Components/BannerMitteilungen";
import DialogMitteilungen from "./Management/Mitteilungen/Components/DialogMitteilungen";
import AppHelpContext from "./Management/Support/Components/AppHelpContext";
import LaenderContext from "./Shared/Countries/Components/LaenderContext";
import RegionenContext from "./Shared/Countries/Components/RegionenContext";
import "./Basis/Themes/index.scss";
import "./Basis/MaterialUI/Themes.scss";
import "@fortawesome/fontawesome-svg-core/styles.css";
// Die folgdenen SCSS-Dateien müssen hier und nicht in der jeweiligen Komponente eingebunden werden,
// da sonst Warnungen entstehen, dass keine korrekte Sortierung gefunden werden konnte (Conflicting Order des mini-css-extract-plugins)
// https://github.com/facebook/create-react-app/issues/5372
import "./Basis/Components/Breadcrumb/Breadcrumb.scss";
import "./Basis/Components/DialogContentText/DialogContentText.scss";
import "./Basis/Components/LoadMoreTableRow/LoadMoreTableRow.scss";
import "./Basis/Components/MaxWidthTableCell/MaxWidthTableCell.scss";
import "./Basis/Components/YesNoDialog/YesNoDialog.scss";

ConsoleLogger.overrideLogging();

export default function App() {
    return (
        <AppSnackbarProvider>
            <GlobalErrorHandler>
                <EmotionCacheProvider>
                    <ThemeProvider theme={Themes.createTheme()}>
                        <CssBaseline />
                        <AuthenticationContext>
                            <LoadingIndicatorSuspense>
                                <IstMandantGueltigContext>
                                    <AppCoffeeMugContext>
                                        <LoadingIndicatorSuspense>
                                            <GraphQLProvider>
                                                <AppRollenContext>
                                                    <PortalPruefer>
                                                        <AppMandantContext>
                                                            <AppKontoContext>
                                                                <AppHelmet>
                                                                    <AppContext>
                                                                        <DndProvider options={HTML5toTouch}>
                                                                            <CloudBrowserRouter>
                                                                                <ViewHistoryContext>
                                                                                    <AppNotificationContext>
                                                                                        <LaenderContext>
                                                                                            <RegionenContext>
                                                                                                <AppDirektdruckContext>
                                                                                                    <AppDownloadContext>
                                                                                                        <AppMenuContext>
                                                                                                            <AppHelpContext>
                                                                                                                <CookieBannerContext>
                                                                                                                    <AppHeader />
                                                                                                                    <BannerMitteilungen />
                                                                                                                    <AppMainContainer>
                                                                                                                        <LoadingIndicatorSuspense>
                                                                                                                            <AppBreadcrumbsContext>
                                                                                                                                <AppBreadcrumbs />
                                                                                                                                <AppRouter />
                                                                                                                            </AppBreadcrumbsContext>
                                                                                                                        </LoadingIndicatorSuspense>
                                                                                                                    </AppMainContainer>
                                                                                                                    <AppSnackbar />
                                                                                                                    <AppCoffeeMug />
                                                                                                                    <AppDirektdruck />
                                                                                                                    <AppDownload />
                                                                                                                    <AppZahlungsmethodeSetzenDialog />
                                                                                                                    <DialogMitteilungen />
                                                                                                                </CookieBannerContext>
                                                                                                            </AppHelpContext>
                                                                                                        </AppMenuContext>
                                                                                                    </AppDownloadContext>
                                                                                                </AppDirektdruckContext>
                                                                                            </RegionenContext>
                                                                                        </LaenderContext>
                                                                                    </AppNotificationContext>
                                                                                </ViewHistoryContext>
                                                                            </CloudBrowserRouter>
                                                                        </DndProvider>
                                                                    </AppContext>
                                                                </AppHelmet>
                                                            </AppKontoContext>
                                                        </AppMandantContext>
                                                    </PortalPruefer>
                                                </AppRollenContext>
                                            </GraphQLProvider>
                                        </LoadingIndicatorSuspense>
                                    </AppCoffeeMugContext>
                                </IstMandantGueltigContext>
                            </LoadingIndicatorSuspense>
                        </AuthenticationContext>
                    </ThemeProvider>
                </EmotionCacheProvider>
            </GlobalErrorHandler>
        </AppSnackbarProvider>
    );
}
